import IFramePage from '@/components/common/IFramePage';
import { useGetMenuNavigationQuery } from '@/features/api/endpoints/menuNavigationEndpoints';
import type { IFrameLinkParams } from '@/models/common.type';
import { useDocumentTitle } from '@mantine/hooks';
import { useParams } from 'react-router-dom';

const AppMenuPage = () => {
  const { menuId } = useParams();

  const { data: menuNavigation } = useGetMenuNavigationQuery(
    {
      id: Number(menuId),
    },
    {
      skip: !menuId,
    },
  );

  useDocumentTitle(menuNavigation?.label ?? '');

  if (menuNavigation?.linkType === 'iframe' || menuNavigation?.linkType === 'digdash') {
    const params = menuNavigation.linkParams as unknown as IFrameLinkParams;
    const title = params?.title ?? menuNavigation.label ?? '';

    const digdashParams = {
      page: menuNavigation.digdashPage ?? '',
      hideBanner: !!menuNavigation.digdashHideBanner,
      hideFilters: !!menuNavigation.digdashHideFilters,
    };

    return (
      <IFramePage
        link={menuNavigation.link ?? ''}
        type={menuNavigation.linkType}
        digdashParams={digdashParams}
        params={{
          ...params,
          title,
        }}
      />
    );
  }

  return null;
};

export default AppMenuPage;
